import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { TmntText } from '../../Common';
import { labelValuePairProp } from '../../../tools/customProps';

const propTypes = {
  rmaNumber: labelValuePairProp.isRequired,
};

export default function QRCodeReturn({ rmaNumber }) {
  return (
    <div className="qr-code-return-wrapper" data-testid="qr-code-return-wrapper">
      <div className="qr-code" data-testid="qr-code">
        <QRCodeSVG value={rmaNumber.value} />
      </div>

      <div className="rma-wrapper" data-testid="rma-wrapper">
        <p className="rma-text"><TmntText tmnt={rmaNumber.label} /></p>
        <p className="rma-number">{rmaNumber.value}</p>
      </div>
    </div>
  );
}

QRCodeReturn.propTypes = propTypes;
